import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestService } from '../../lib/services';
import { CareerSubDomain } from '../../lib/classes/careerSubDomain';
import {
  EMPTY_LISTING,
  JobListing,
  JobListingItem,
} from '../models/listing.model';
import { CareerListing } from '../../settings-module/components/career-page/career-page.model';

@Injectable()
export class ListingService {
  private _apiEndpoint = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private _requestService: RequestService
  ) {}

  public getJobListing(job_id: string | number) {
    return this._requestService.request<JobListing>(
      'GET',
      `${this._apiEndpoint}listings/job/${job_id}/job-listing/`
    );
  }

  public getTemplateListing(job_id: number) {
    return this._requestService.request<JobListing>(
      'GET',
      `${this._apiEndpoint}listings/template/${job_id}/job-listing/`
    );
  }

  public createUpdateJobListing(
    jobId: number,
    listing?: JobListing,
    forTemplate = false
  ): Observable<JobListing> {
    if (!listing) {
      listing = {
        ...EMPTY_LISTING,
        job_id: jobId,
      };
    }
    if (forTemplate) {
      if (listing.id) {
        return this._requestService.request<JobListing>(
          'PUT',
          `${this._apiEndpoint}listings/job-listing/${listing.id}/`,
          null,
          listing
        );
      } else {
        return this._requestService.request<JobListing>(
          'POST',
          `${this._apiEndpoint}listings/template/job-listing/`,
          null,
          listing
        );
      }
    } else {
      if (listing.id) {
        return this._requestService.request<JobListing>(
          'PUT',
          `${this._apiEndpoint}listings/job-listing/${listing.id}/`,
          null,
          listing
        );
      } else {
        return this._requestService.request<JobListing>(
          'POST',
          `${this._apiEndpoint}listings/job-listing/`,
          null,
          listing
        );
      }
    }
  }

  public getCareerListing(unit_id: number) {
    return this._requestService.request<CareerListing>(
      'GET',
      `${this._apiEndpoint}listings/company/${unit_id}/career-page/`
    );
  }

  public createUpdateCareerListing(listing: CareerListing) {
    if (listing.id) {
      return this._requestService.request<CareerListing>(
        'PUT',
        `${this._apiEndpoint}listings/career-page/${listing.id}/`,
        null,
        listing
      );
    } else {
      return this._requestService.request<CareerListing>(
        'POST',
        `${this._apiEndpoint}listings/career-page/`,
        null,
        listing
      );
    }
  }

  public createCareerSubdomain(subDomain: CareerSubDomain) {
    return this._requestService.request(
      'POST',
      `${this._apiEndpoint}listings/career-page/subdomain/`,
      null,
      subDomain
    );
  }

  public deleteCareerSubdomain(subDomain: CareerSubDomain) {
    return this._requestService.request(
      'DELETE',
      `${this._apiEndpoint}listings/career-page/subdomain/${subDomain.id}/`,
      null,
      subDomain
    );
  }

  public deleteListingItem(item: JobListingItem) {
    return this._requestService.request(
      'DELETE',
      `${this._apiEndpoint}listings/listing-item/${item.id}/?type=${item.type}`,
      null
    );
  }
}
